var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:_vm.subMenu && 'sub-menu-item',style:(_vm.style)},[_c('a',_vm._b({attrs:{"href":_vm.href}},'a',_vm.$attrs,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }